import { standardCallback as standardBarcodeScannerCallback } from '../shared/barcodeScanner';
import onScan from 'onscan.js';

export default {
    mounted() {
        $(window.document).scannerDetection({
            timeBeforeScanTest: 200, // wait for the next character for upto 200ms
            startChar: [16], // Prefix character for the cabled scanner (OPL6845R)
            endChar: [13], // be sure the scan is complete if key 13 (enter) is detected
            avgTimeByChar: 40, // it's not a barcode if a character takes longer than 40ms
        });

        $(window.document).on('scannerDetectionComplete', (e, data) => {
            if (this.shouldIgnoreElementForScannerDetection(e.target)) {
                return;
            }

            const scanEvent = this.$bus._events['barcode-scan'];
            if (scanEvent && scanEvent.length > 0) {
                this.$bus.$emit('barcode-scan', data.string || '');
            } else {
                standardBarcodeScannerCallback(data.string || '');
            }
        });
    },
    mountedNew() {
        onScan.attachTo(window.document, {
            suffixKeyCodes: [13], // be sure the scan is complete if key 13 (enter) is detected
            prefixKeyCodes: [16], // Prefix character for the cabled scanner (OPL6845R)
            avgTimeByChar: 40, // it's not a barcode if a character takes longer than 40ms
            timeBeforeScanTest: 200, // wait for the next character for upto 200ms
            //reactToPaste: true, // Compatibility to built-in scanners in paste-mode (as opposed to keyboard-mode)
        });

        document.addEventListener('scan', (e) => {
            if (this.shouldIgnoreElementForScannerDetection(e.target)) {
                return;
            }

            const scanCode = e.detail.scanCode;
            //Quantity can be fetched with: e.detail.qty;
            const scanEvent = this.$bus._events['barcode-scan'];

            if (scanEvent && scanEvent.length > 0) {
                this.$bus.$emit('barcode-scan', scanCode);
            } else {
                standardBarcodeScannerCallback(scanCode);
            }
        });
    },
    methods: {
        // Can be used in browser like so: window.newVueApp.simulateOnScan('PR123457')
        simulateOnScan(code) {
            onScan.simulate(window.document, code);
        },
        simulateOldOnScan(code) {
            $(window.document).scannerDetection(code);
        },
        shouldIgnoreElementForScannerDetection(element) {
            if (element.dataset && element.dataset.ignoreScannerDetection) {
                return true;
            }

            if (
                element.activeElement &&
                element.activeElement.hasAttribute('ignore-scanner-detection')
            ) {
                return true;
            }

            return false;
        },
    },
};
